import { render, staticRenderFns } from "./actionbarTab.vue?vue&type=template&id=0d4320d8&scoped=true&"
import script from "./actionbarTab.vue?vue&type=script&lang=js&"
export * from "./actionbarTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4320d8",
  null
  
)

export default component.exports